<template>
  <div>

    <z-centralized-toolbar>
      <v-btn id="btn-adicionar" color="primary" @click="novaNotaFiscal" :disabled="!$auth.can('notas_fiscais:adicionar')">
        <v-icon left>{{ $icon.MOVIMENTACOES }}</v-icon>
        Nova Nota Fiscal de Serviço
      </v-btn>

      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        :disabled="!$auth.can('notas_fiscais:configuracoes')"
        @click="$refs.dialogoEmitente.abrir()"
      >
        <v-icon left>{{ $icon.SISTEMA }}</v-icon>
        Configurações
      </v-btn>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-container fluid>
      <z-cabecalho>Notas Fiscais de Serviço</z-cabecalho>
      <v-row class="mb-3" justify="center" align="stretch">
        <v-col>
          <v-card>
            <v-toolbar flat color="white" dense>
              <h3 class="text-subtitle-2">Filtro</h3>
            </v-toolbar>
            <v-divider></v-divider>

            <v-card-text>
              <v-form>
                <v-row>
                  <v-col sm="12">
                    <z-autocomplete
                      v-model="filtro.tomador_id"
                      :items="tomadores"
                      label="Cliente/Tomador"
                      hide-details
                      clearable
                    ></z-autocomplete>
                  </v-col>
                  <v-col sm="4">
                    <z-text-field
                      v-model="filtro.nfse_numero"
                      label="Número NFS-e"
                      hide-details
                      clearable
                    ></z-text-field>
                  </v-col>
                  <v-col sm="4">
                    <z-date-picker-menu
                      v-model="filtro.data_inicial"
                      label="Data Inicial"
                      hide-details
                      clearable
                      left
                      @change="onChangeDataInicial"
                      ></z-date-picker-menu>
                    </v-col>
                    <v-col sm="4">
                      <z-date-picker-menu
                      v-model="filtro.data_final"
                      label="Data Final"
                      hide-details
                      clearable
                      left
                      @change="onChangeDataFinal"
                    ></z-date-picker-menu>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn flat @click="exportar" :loading="loading" :disabled="notasfiscais.data && notasfiscais.data.length == 0">
                <v-icon left>mdi-file-excel-outline</v-icon>
                Exportar
              </v-btn> -->
              <v-btn color="primary" @click="listar" :loading="loading">Filtrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-subheader>
        Notas Fiscais
        <v-spacer></v-spacer>
        <v-icon small :color="cor_avulsa" class="pr-2">mdi-circle</v-icon>Notas Avulsas
      </v-subheader>


      <v-card>
        <v-tabs
          v-model="tabAtiva"
          @change="listar"
        >
          <v-tab v-for="(tab, index) in tabs" :key="index">
            {{ tab.text }} ({{ tab.count }})
          </v-tab>
          <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>

        <v-divider></v-divider>

        <v-row justify="center" align="stretch">
          <v-col>

              <v-data-table
                disable-sort
                :loading="loading"
                :headers="headers"
                :items="notasfiscais.data"
                :server-items-length="total_items"
                :footer-props="$v.FOOTER_PROPS"
                :options.sync="pagination"
              >
                <template #item="props">
                  <tr>
                    <td>
                      {{ props.item.id }}
                    </td>
                    <td class="text-xs-center text-no-wrap">
                      <v-btn
                        v-if="props.item.rps_situacao == 1 || props.item.rps_situacao == 3"
                        color="primary"
                        small
                        :disabled="props.item.rps_situacao == 2"
                        @click="emitirNFSE(props.item)"
                      >Emitir</v-btn>
                      <span v-else>{{ props.item.nfse_numero }}</span>

                      <v-btn
                        v-if="props.item.rps_situacao == 2"
                        color="orange"
                        dark
                        small
                        :loading="props.item.consultando"
                        @click="consultarProtocolo(props.item)"
                      >Consultar</v-btn>

                      <v-btn
                        v-if="props.item.rps_situacao == 4 || props.item.rps_situacao == 3"
                        color="green"
                        dark
                        small
                        :loading="props.item.consultando"
                        @click="consultarNFSe(props.item)"
                      >Consultar</v-btn>

                    </td>
                    <td class="text-xs-left text-no-wrap">
                      <z-status-nfse
                        :situacao="props.item.rps_situacao"
                        @click="onClickStatus(props.item)"
                      >Aguardando</z-status-nfse>

                      <v-icon title="Nota Avulsa" small :color="cor_avulsa" v-if="props.item.tipo_nota == 'avulsa'">mdi-circle</v-icon>
                    </td>
                    <td class="text-no-wrap">{{ props.item.rps_protocolo }}</td>
                    <td class="text-no-wrap">{{ props.item.rps_data_emissao | dataBR }}</td>
                    <td class="text-no-wrap overflow-hidden text-truncate" style="position: relative; max-width: 200px" :title="props.item.emitente.razao">
                      {{ props.item.emitente.razao }}
                    </td>

                    <td class="text-no-wrap overflow-hidden text-truncate"  :title="props.item.tomador.nome">
                      <v-hover v-slot="{ hover }">
                        <div class="d-flex align-center justify-space-between">
                          <span>
                            {{ props.item.tomador.nome }}
                          </span>
                          <z-table-items :show="hover">
                            <v-btn color="primary" small fab :to="{ name: 'ClientesEditar', params: { id: props.item.tomador.id} }" target="_blank" title="Editar Cliente/Tomador">
                              <v-icon>{{ $icon.EDITAR }}</v-icon>
                            </v-btn>
                          </z-table-items>
                        </div>
                      </v-hover>
                    </td>

                    <td class="text-right">{{ props.item.servico_valor_liquido_nfse | valorBR }}</td>
                    <td class="text-center text-no-wrap">
                      <!-- <v-tooltip bottom v-if="props.item.rps_situacao == 4 && props.item.status == 1">
                        <template #activator="{ on, attrs }">
                          <v-btn icon ripple @click.stop="substituir(props.item)">
                            <v-icon color="grey darken-1">mdi-swap-vertical-bold</v-icon>
                          </v-btn>
                          <span>Substituir</span>
                        </template>
                      </v-tooltip> -->
                      <v-tooltip
                        bottom
                        v-if="[4, -4].includes(props.item.rps_situacao)"
                      >
                        <template #activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            ripple
                            @click.stop="imprimir(props.item)"
                          >
                            <v-icon color="grey darken-1">{{ $icon.IMPRIMIR }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Imprimir</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            ripple
                            @click.stop="abrirDialogoExcluir(props.item)"
                          >
                            <v-icon color="grey darken-1">{{ $icon.EXCLUIR }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>

          </v-col>
        </v-row>
      </v-card>

    </z-container>

    <z-dialogo ref="dialogoExcluir" titulo="Deseja excluir essa NFSe?" largura="600px" :loading="loading_excluir">
        <template #texto>
          {{ nota.tomador.nome || ""}}
        </template>

        <template #actions_right>
          <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="loading_excluir">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarExcluir" :loading="loading_excluir" :disabled="loading_excluir">Excluir</v-btn>
        </template>
    </z-dialogo>

    <!-- <CancelamentoNotaFiscal ref="dialogoCancelamentoNotaFiscal" @onsubstituir="listar"></CancelamentoNotaFiscal> -->

    <EmitenteForm
      ref="dialogoEmitente"
      :emitente="emitente"
    ></EmitenteForm>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  import globals from "@/app/globals";
  import notaFiscaisApi from '@/app/services/notasfiscais.js';
  import qs from 'qs';

  import CancelamentoNotaFiscal from './CancelamentoNotaFiscal.vue'
  import EmitenteForm from './emitentes/EmitenteForm.vue'

  import { formataCPFCNPJ } from '@/app/helpers/formatacoes.js';


  export default {
    name: 'NotasFiscaisLista',

    components: {
      CancelamentoNotaFiscal,
      EmitenteForm
    },

    inject: ['rootRefs'],

    watch: {
      pagination: {
        handler() {
          this.listar();
        },
        deep: true,
      },

      filtro: {
        handler() {
          if (this.first_load) {
            this.first_load = false;
            return;
          }

          this.listar();
        },
        deep: true,
      },

    },

    data() {
      return {
        first_load: true,
        cor_avulsa: 'blue-grey',
        globals,
        loading_excluir: false,
        search: '',
        nota: {
          tomador: {
            razao: ""
          }
        },
        headers:[
          { text: '#', value: 'id', width: '10px', sortable: false},
          { text: 'Número NFSe', value: 'nfse_numero', align: 'center', width: '10px', sortable: false},
          { text: 'Situação', value: 'rps_situacao', align: 'center', width: '10px', sortable: false},
          { text: 'Protocolo', value: 'rps_protocolo', width: '10px', sortable: false},
          { text: 'Data Emissão', value: 'rps_data_emissao', width: '10px', sortable: false},
          { text: 'Emitente', value: 'emitente.razao', sortable: false},
          { text: 'Tomador', value: 'tomador.razao', sortable: false},
          { text: 'Valor Nota', value: 'servico_valor_liquido_nfse', align: 'right', sortable: false},
          { text: 'Opções', value: '', align: 'center', sortable: false}
        ],

        filtro: {
          emitente_id: null,
          tomador_id: null,
          nfse_numero: null,
          cpf_cnpj: null,
          data_inicial: null,
          data_final: null,
          lista: 'autorizadas',
        },

        pagination: {
          descending: false,
          page: 1,
        },
        consultando: false,
        tabAtiva: 0,
        emitente: {},
        // tabs: [
        //   { text: 'Aguardando Emissão', value: 'aguardando_emissao', count: this.count_notas_aguardando_emissao },
        //   { text: 'Em Processamento', value: 'processamento', count: this.count_notas_processamento },
        //   { text: 'Erro', value: 'erro', count: this.count_notas_erro },
        //   { text: 'Autorizadas', value: 'autorizadas', count: this.count_notas_autorizadas },
        // ]
      }
    },

    computed: {
      ...mapState('notasfiscais', ['notasfiscais', 'notafiscal', 'loading', 'count_notas_aguardando_emissao', 'count_notas_autorizadas', 'count_notas_erro', 'count_notas_processamento']),

      tabs() {
        return [
          { text: 'Aguardando Emissão', value: 'aguardando_emissao', count: this.count_notas_aguardando_emissao },
          { text: 'Em Processamento', value: 'processamento', count: this.count_notas_processamento },
          { text: 'Erro', value: 'erro', count: this.count_notas_erro },
          { text: 'Autorizadas', value: 'autorizadas', count: this.count_notas_autorizadas },
        ]
      },

      tomadores() {
        return this.$store.state.listas.clientes.map(cliente => {
          return {
            'text': cliente.nome,
            'value': cliente.id,
            'cnpj': cliente.cpfcnpj,
          }
        })
      },

      total_items() {
        return this.notasfiscais.total || 0;
      }
    },

    async mounted() {
      this.filtro = {
        emitente_id: null,
        tomador_id: null,
        nfse_numero: null,
        cpf_cnpj: null,
        data_inicial: this.$dayjs().subtract(30, 'days').format('YYYY-MM-DD'),
        data_final: this.$dayjs().format('YYYY-MM-DD'),
        lista: 'autorizadas',
      }

      // await this.$store.dispatch('listas/emitentes');
      await this.$store.dispatch('listas/clientes');
      // await this.listar();

    },

    methods: {
      ...mapActions('notasfiscais', ['listarNotasFiscais', 'excluirNotaFiscal', 'carregarSubstituta']),

      async listar() {

        const tipos_lista = [
          'aguardando_emissao',
          'autorizadas',
          'processamento',
          'erro'
        ];

        const filtro = { ...this.filtro };
        filtro.lista = this.tabs[this.tabAtiva].value;
        await this.listarNotasFiscais({...filtro, ...this.pagination});
      },

      abrirDialogoExcluir(nota) {
        if (!!nota.nfse_numero && !!nota.rps_protocolo) {
          this.rootRefs.notifications.notificar("Não é possível excluir essa nota.");
          return false;
        }

        this.nota = nota;
        this.$refs.dialogoExcluir.abrir();
      },


      async confirmarExcluir() {
        try {
          this.loading_excluir = true;

          await this.excluirNotaFiscal(this.nota.id);

          this.$refs.dialogoExcluir.fechar()
        } finally {
          this.loading_excluir = false;
        }
      },

      excluir() {

      },

      emitirNFSE(nota) {
        // this.faturamento.subfatura_index = subfatura_index;
        // this.$store.commit('notasfiscais/SET_FATURA', this.faturamento);
        this.$router.push({
          name: 'NotasFiscaisEditar',
          params: {
            id: nota.id
          }
        })
      },

      imprimir(nota) {
        // console.log(nota);
        if (this.$config.IS_PRODUCTION) {
          this.abrirJanela(`http://visualizar.ginfes.com.br/report/consultarNota?__report=nfs_ver4&cdVerificacao=${nota.nfse_codigo_verificacao}&numNota=${nota.nfse_numero}&cnpjPrestador=null`)
        } else {
          this.abrirJanela(`http://caruaru.ginfesh.com.br/report/consultarNota?__report=nfs_ver4&cdVerificacao=${nota.nfse_codigo_verificacao}&numNota=${nota.nfse_numero}&cnpjPrestador=null`)
        }
      },

      async consultarProtocolo(nota) {
        try {
          this.$set(nota, 'consultando', true);

          const response = await notaFiscaisApi.consultarProtocolo(nota.protocolo_emissao);

          if (response.situacao == 4) {
            const nota_fiscal = await this.carregarNota(nota.id);
            nota.nfse_codigo_verificacao = nota_fiscal.nfse_codigo_verificacao;
            nota.rps_protocolo = nota_fiscal.rps_protocolo;
            nota.rps_situacao = nota_fiscal.rps_situacao;
            nota.nfse_numero = nota_fiscal.nfse_numero;
            nota.notafiscal = nota_fiscal.notafiscal;
          }

          if (response.situacao == 3) {
            await this.consultarNFSe(nota);
          }

        } catch (error) {
          const { retorno_codigo, retorno_mensagem, retorno_correcao } = error.response;

          nota.retorno_codigo = retorno_codigo;
          nota.retorno_mensagem = retorno_mensagem;
          nota.retorno_correcao = retorno_correcao;
          nota.rps_situacao = 3;

        } finally {
          this.$set(nota, 'consultando', false);
        }
      },

      async consultarNFSe(nota) {
        try {
          this.$set(nota, 'consultando', true);
          const response = await notaFiscaisApi.consultarNota(nota.protocolo_emissao);

          if (response.mensagem == "Nota Fiscal emitida com sucesso") {
            const nota_fiscal = await this.carregarNota(nota.id);
            nota.nfse_codigo_verificacao = nota_fiscal.nfse_codigo_verificacao;
            nota.rps_protocolo = nota_fiscal.rps_protocolo;
            nota.rps_situacao = nota_fiscal.rps_situacao;
            nota.nfse_numero = nota_fiscal.nfse_numero;
            nota.notafiscal = nota_fiscal.notafiscal;
          }

        } catch (error) {

          if (error.response) {
            const { data } = error.response;
            console.log({...data});

            if (data.codigo) {
              nota.rps_situacao = 3;
            }

            if (data.codigo == "X101") {
              const nota_fiscal = await this.carregarNota(nota.id);
              nota.nfse_codigo_verificacao = nota_fiscal.nfse_codigo_verificacao;
              nota.rps_protocolo = nota_fiscal.rps_protocolo;
              nota.rps_situacao = nota_fiscal.rps_situacao;
              nota.nfse_numero = nota_fiscal.nfse_numero;
              nota.notafiscal = nota_fiscal.notafiscal;
            }
          }

        } finally {
          this.consultando = false;
          this.$set(nota, 'consultando', false);
        }
      },

      async onClickStatus(nota) {
        let { retorno_codigo, retorno_mensagem, retorno_correcao, nota_substituta, nfse_numero } = nota;

        if (nota_substituta) {
          await this.carregarSubstituta(nfse_numero);
          this.$refs.dialogoCancelamentoNotaFiscal.abrir();
        }

        if (retorno_mensagem) {
          console.log({
            retorno_codigo,
            retorno_mensagem,
            retorno_correcao
          })
        }
      },

      async carregarNota(notafiscal_id) {
        await this.$store.dispatch('notasfiscais/carregarNfse', notafiscal_id);
        return this.$store.state.notasfiscais.notafiscal;
      },

      async exportar() {
        try {
          this.loading = true;
          // await this.$axios.get('exportar-notas-excel', this.filtro);
          if (this.$config.IS_PRODUCTION) {
            this.abrirJanela('https://gft.etapps.com.br/exportar-notas-excel?'  + qs.stringify(this.filtro));
          } else {
            this.abrirJanela('http://localhost:8000/exportar-notas-excel?'  + qs.stringify(this.filtro));
          }
          // await this.exportarExcel(this.filtro);
        } catch (error) {
          throw error
        } finally {
          this.loading = false;
        }
      },

      substituir(nota) {

        this.$store.commit('notasfiscais/SET_NOTAFISCAL_CANCELADA', {
          nfse_numero: nota.nfse_numero,
          nfse_codigo_verificacao: nota.nfse_codigo_verificacao,
          nfse_data_emissao: nota.nfse_data_emissao,
          emitente_id: nota.emitente_id,
          tomador_cpfcnpj: formataCPFCNPJ(nota.tomador_cpfcnpj),
          tomador_razao_social: nota.tomador_razao_social,
          status: nota.status,
          nota_substituida: nota.nota_substituida,
          servico_valor_liquido_nfse: nota.servico_valor_liquido_nfse,
        });

        this.$refs.dialogoCancelamentoNotaFiscal.abrir();
      },

      novaNotaFiscal() {
        this.$router.push({
          name: 'NotasFiscaisAdicionar'
        })
      },

      onChangeDataInicial() {
        if (this.filtro.data_final == null || this.filtro.data_final == '')
          this.filtro.data_final = this.filtro.data_inicial;
      },

      onChangeDataFinal() {
        if (this.filtro.data_inicial == null || this.filtro.data_inicial == '')
          this.filtro.data_inicial = this.filtro.data_final;
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
